import Axios from "axios";
import { SET_MONEY_REQUISITION_LIST, UNSET_MONEY_REQUISITION_LIST } from "@/store/mutation-types";
import {
  getMoneyRequisitionList as getMoneyRequisitionListApi,
  getMoneyRequisitionById as getMoneyRequisitionByIdApi,
  saveUpdateMoneyRequisition as saveUpdateMoneyRequisitionApi,
  disburseMoneyRequisition as disburseMoneyRequisitionApi,
} from "@/store/api";

// Initial State
const state = {
  getMoneyRequisitionList: [],
  editingMoneyRequisition: null,
  viewingMoneyRequisition: null,
};

// Getters
const getters = {
  getMoneyRequisitionList(state) {
    return state.getMoneyRequisitionList;
  },
  getEditingMoneyRequisition: (state) => state.editingMoneyRequisition,
  getViewingMoneyRequisition: (state) => state.viewingMoneyRequisition,
};

// Mutations
const mutations = {
  [SET_MONEY_REQUISITION_LIST](state, data) {
    state.getMoneyRequisitionList = data;
  },
  [UNSET_MONEY_REQUISITION_LIST](state) {
    state.getMoneyRequisitionList = [];
  },
  setEditingMoneyRequisition(state, requisition) {
    state.editingMoneyRequisition = requisition;
  },
  setViewingMoneyRequisition(state, requisition) {
    state.viewingMoneyRequisition = requisition;
  },
};

// Actions
const actions = {
  /**
   * Get money requisition list
   */
  getMoneyRequisitionList({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(getMoneyRequisitionListApi, { params: data})
        .then((response) => {
          commit(SET_MONEY_REQUISITION_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_MONEY_REQUISITION_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  /**
   * Get money requisition by id
   */
  getMoneyRequisitionById({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(`${getMoneyRequisitionByIdApi}/${id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  /**
   * Save or update money requisition
   */
  saveUpdateMoneyRequisition({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    const isUpdate = data.id;
    const url = isUpdate
      ? `${saveUpdateMoneyRequisitionApi}/${data.id}`
      : saveUpdateMoneyRequisitionApi;
    const method = isUpdate ? "put" : "post";

    return new Promise((resolve, reject) => {
      Axios[method](url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  /**
   * Disburse money requisition
   */
  disburseMoneyRequisition({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(`${disburseMoneyRequisitionApi}/${id}/disbursement`, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
